export enum UploadType {
  COMPANY = 'companies', // Company
  EVENT = 'cards', // Cards
  OTHER = 'other', // Cards
  PROFILE = 'profiles',
}
